import styled from 'styled-components'
import { colors, breakpoints } from '@/styles'

const Wrapper = styled.div`
  position: relative;
  background: ${colors.white};
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 40px;
  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    padding: 20px 8px;
  }
`

export default Wrapper
